import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Bounce } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts } from '../../settings/';
import { DelayLink } from '../../components';

import './NotFound.scss';

class NotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
      user: '',
      password: '',
    };

    this.images = images;
    this.texts = texts;

    this.runTransition = this.runTransition.bind(this);
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.showHeader();
    Actions.hideMenu();
    Actions.hideFooter();
  }

  componentWillUnmount() {}

  render() {
    const classItem = ['not_found'];

    return (
      <div className="views">
        <Helmet>
          <title>404 - Não encontrado - {this.texts.title}</title>
        </Helmet>

        <div className={classItem.join(' ')}>
          <div className="not_found_view">
              <Bounce top>
                <h1>404 =(</h1>
                <p>Página não encontrada</p>
              </Bounce>
              <Bounce bottom>
                <DelayLink to="/" className="btn">home</DelayLink>
              </Bounce>
          </div>
        </div>
      </div>
    );
  }
}

export { NotFound };
